import React from "react";
import { FormLabel, Select, Typography, MenuItem, SelectChangeEvent, Box, SxProps, Theme } from "@mui/material";
import theme from "assets/styles/themes";
import CustomIcon from "components/CustomIcon";
import icons from "enums/icons";
import { whiteSpaceToHyphen } from "utils";

interface YearPickerProps {
    label: string;
    date: string;
    setDate: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>) => void;
    optionsMessage?: string;
    options: number[];
    sx?: SxProps<Theme>;
}

const YearPicker = ({ label, date, setDate, optionsMessage, options, sx }: YearPickerProps) => {
    const labelLastPart = whiteSpaceToHyphen(label);

    return (
        <Box sx={{ ...sx }}>
            <FormLabel
                htmlFor={`date-range-${labelLastPart}`}
                sx={{ fontSize: 11, fontWeight: 500, mb: 1, display: "block" }}
            >
                {label}
            </FormLabel>
            <Select
                displayEmpty
                id={`date-range-${labelLastPart}`}
                name={`date-range-${labelLastPart}`}
                labelId={`date-range-${labelLastPart}`}
                value={date}
                onChange={(event) => setDate(event)}
                IconComponent={(props) => <CustomIcon icon={icons.date} {...props} sx={{ fontSize: 12 }} />}
                renderValue={(selected) =>
                    selected === "" ? (
                        <Typography sx={{ fontSize: 11, color: theme.palette.text.secondary }}>yyyy</Typography>
                    ) : (
                        selected
                    )
                }
                sx={{
                    width: 128,
                    height: 35,
                    "& .MuiSelect-select": {
                        padding: "0 0 0 12px",
                    },
                    "& .MuiSelect-icon": {
                        right: "12px !important",
                        transform: "none !important",
                    },
                }}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            width: 187,
                            borderRadius: 4,
                            boxShadow: "0px 10px 15px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.05)",
                        },
                    },
                }}
            >
                {optionsMessage && (
                    <MenuItem
                        disabled
                        value=""
                        sx={{
                            backgroundColor: `${theme.palette.common.white} !important`,
                            color: theme.palette.text.disabled,
                            fontSize: 12,
                            width: 155,
                            whiteSpace: "wrap",
                            opacity: "1 !important",
                        }}
                    >
                        {optionsMessage}
                    </MenuItem>
                )}
                {options.map((year) => (
                    <MenuItem key={year} value={`${year}`}>
                        {year}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
};

export default YearPicker;
